/* MatchBoox V199 — gerichte beeldcorrecties en bestaande tekstcorrecties. */
(() => {
  'use strict';

  const replaceBoxTerm = (value) => String(value || '')
    .replace(/\bLuciferdoosjes\b/g, 'Doosjes')
    .replace(/\bluciferdoosjes\b/g, 'doosjes')
    .replace(/\bLuciferdoosje\b/g, 'Doosje')
    .replace(/\bluciferdoosje\b/g, 'doosje');

  const updateTerms = (scope = document.body) => {
    if (!scope) return;
    const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        return /luciferdoosje/i.test(node.nodeValue || '')
          && !['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEMPLATE'].includes(node.parentElement?.tagName)
          ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => { node.nodeValue = replaceBoxTerm(node.nodeValue); });
    scope.querySelectorAll?.('[alt],[title],[aria-label]').forEach((element) => {
      ['alt', 'title', 'aria-label'].forEach((attribute) => {
        if (element.hasAttribute(attribute)) element.setAttribute(attribute, replaceBoxTerm(element.getAttribute(attribute)));
      });
    });
  };

  const setMakerHeroAlt = () => {
    const authorsRoot = document.querySelector('.mb-page-content[data-page-handle="auteurs"]');
    const illustratorsRoot = document.querySelector('.mb-page-content[data-page-handle="illustratoren"]');
    const authors = authorsRoot?.querySelector('.mb-v126-maker-hero img');
    const illustrators = illustratorsRoot?.querySelector('.mb-v126-maker-hero img');
    if (authors) {
      authors.src = authorsRoot.dataset.authorsHeroImage || authors.src;
      authors.removeAttribute('srcset');
      authors.alt = 'Rood MatchBoox-boekje dat volledig als harmonica is opengevouwen';
    }
    if (illustrators) {
      illustrators.src = illustratorsRoot.dataset.illustratorsHeroImage || illustrators.src;
      illustrators.removeAttribute('srcset');
      illustrators.alt = illustratorsRoot.dataset.illustratorsHeroAlt || 'Close-up van de gevouwen pagina’s in een geopend MatchBoox-doosje';
    }
  };

  const markStoryTitle = () => {
    const story = document.querySelector('.mb-page-content[data-page-handle="the-matchboox-story"]');
    if (!story) return;
    const storyTitle = [...story.querySelectorAll('h1, h2, h3')]
      .find((heading) => heading.textContent.trim() === 'Van kunstproject naar uitgeverij');
    storyTitle?.classList.add('mb-v198-hero-title');
    const peopleTitle = story.querySelector('.mbo-title');
    if (!storyTitle || !peopleTitle) return;
    const titleStyle = window.getComputedStyle(storyTitle);
    ['font-family', 'font-size', 'font-weight', 'line-height', 'letter-spacing'].forEach((property) => {
      peopleTitle.style.setProperty(property, titleStyle.getPropertyValue(property), 'important');
    });
  };

  const init = () => {
    updateTerms();
    setMakerHeroAlt();
    markStoryTitle();
    const observer = new MutationObserver((changes) => changes.forEach((change) => change.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) updateTerms(node);
      else if (node.nodeType === Node.TEXT_NODE && /luciferdoosje/i.test(node.nodeValue || '')) node.nodeValue = replaceBoxTerm(node.nodeValue);
    })));
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', () => { updateTerms(); setMakerHeroAlt(); markStoryTitle(); });
})();
